import React from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';

const EditPasswordModal = ({
  open,
  editingUserId,
  users,
  error,
  message,
  editPassword,
  showEditPasswordInput,
  loading,
  onClose,
  onSubmit,
  onPasswordChange,
  onTogglePasswordVisibility,
}) => {
  if (!open || !editingUserId) return null;

  const userEmail = users.find((u) => u.id === editingUserId)?.email;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-card"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="edit-password-title"
      >
        <div className="modal-header">
          <h3 id="edit-password-title">Edit User Password</h3>
          <button
            className="modal-close"
            onClick={onClose}
            type="button"
            aria-label="Close"
            title="Close"
          >
            ✕
          </button>
        </div>

        <form onSubmit={onSubmit} className="modal-form">
          {error && <div className="error-message">{error}</div>}
          {message && <div className="success-message">{message}</div>}

          <p className="modal-info">
            Editing password for: <strong>{userEmail}</strong>
          </p>

          <div className="form-group">
            <label htmlFor="edit-password">New Password</label>
            <div className="password-input-wrapper">
              <input
                id="edit-password"
                type={showEditPasswordInput ? 'text' : 'password'}
                value={editPassword}
                onChange={(e) => onPasswordChange(e.target.value)}
                placeholder="Enter new password"
                required
                disabled={loading}
                autoFocus
                autoComplete="new-password"
              />
              <button
                type="button"
                className="toggle-password-btn-small"
                onClick={onTogglePasswordVisibility}
                disabled={loading}
              >
                {showEditPasswordInput ? (
                  <AiOutlineEyeInvisible size={18} />
                ) : (
                  <AiOutlineEye size={18} />
                )}
              </button>
            </div>
          </div>

          <div className="modal-buttons">
            <button type="button" className="cancel-button" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? 'Updating...' : 'Update Password'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPasswordModal;
